class Presentationjs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const imageWrapper = document.querySelector(".custom-slider-wrapper");
    const imageSlides = document.querySelectorAll(".custom-slide");
    const totalSlides = imageSlides.length;

    function updateImageSlider(index) {
      const slides = document.querySelectorAll(".custom-slide");
      slides.forEach((slide, i) => {
        slide.classList.remove("active");
        if (i === index || i === index + totalSlides) {
          slide.classList.add("active");
        }
      });

      const slideWidth = 216;
      const activeSlideWidth = 296;
      let offset = 0;

      for (let i = 0; i < index; i++) {
        offset += slideWidth;
      }

      imageWrapper.style.transform = `translateX(-${offset}px)`;
    }

    updateImageSlider(0);

    const textSwiper = new Swiper(".swiper__texts", {
      loop: false,
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      on: {
        slideChange: function () {
          updateImageSlider(this.activeIndex);
        },
      },
    });

     const textSwiperMobile = new Swiper('.swiper__texts-mobile', {
          slidesPerView: 1.3,
          spaceBetween: 10,
          loop: true,
          effect: 'creative',
          // Configuration de l'effet Creative
          creativeEffect: {
              // Limiter l'effet aux slides proches (optionnel)
              limitProgress: 3,
              // Transformation pour le slide précédent
              prev: {
                  scale: 0.8, // Réduire à 80% pour le slide précédent
                  translate: ['-100%', '-10%', 0], // Déplacer à gauche
                  style: {
                      top: '-10%', // Positionner en haut
                  }
              },
              // Transformation pour le slide suivant
              next: {
                  scale: 0.8, // Réduire à 80% pour le slide suivant
                  translate: ['100%', '-10%', 0], // Déplacer à droite
                  style: {
                      top: '-10%', // Positionner en haut
                  }
              },
              // Transformation pour le slide actif (facultatif, par défaut scale: 1)
              perspective: true, // Activer les transformations 3D
          },
          navigation: {
              nextEl: '.presentation__navigation-mobile .swiper-button-next',
              prevEl: '.presentation__navigation-mobile .swiper-button-prev',
          },
          pagination: {
              el: '.presentation__navigation-mobile .swiper-pagination',
              clickable: true,
          },
          breakpoints: {
              750: {
                  slidesPerView: 2.2,
              },
          }

      });
  }
}

customElements.define("presentation-js", Presentationjs);
